/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Tooltip_Credential_OwnerInputs */

const es_settings_files_tooltip_credential_owner = /** @type {(inputs: Settings_Files_Tooltip_Credential_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dueño de la credencial`)
};

const en_settings_files_tooltip_credential_owner = /** @type {(inputs: Settings_Files_Tooltip_Credential_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credential owner`)
};

/**
* | output |
* | --- |
* | "Credential owner" |
*
* @param {Settings_Files_Tooltip_Credential_OwnerInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_tooltip_credential_owner = /** @type {((inputs?: Settings_Files_Tooltip_Credential_OwnerInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Tooltip_Credential_OwnerInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_tooltip_credential_owner(inputs)
	return en_settings_files_tooltip_credential_owner(inputs)
});
export { settings_files_tooltip_credential_owner as "settings.files.tooltip.credential_owner" }